import React from 'react'
import DoctorListing from './DoctorListing'
import HoverCardDoctors from './HoverCardDoctors'
import MinimalCardDoctors from './MinimalCardDoctors'
import OverlayRevealDoctors from './OverlayRevealDoctors'
import { useSelector } from 'react-redux'
import StaticDoctorListing from './StaticDoctorListing'

function DoctorListingWrapper() {
    const sitedata = useSelector((store) => store.global.loginData);
    return (

        <>
            {sitedata?.theme_specialist === "hover-card" ? (
                <HoverCardDoctors />
            ) : sitedata?.theme_specialist === "minimal-grid" ? (
                <MinimalCardDoctors />
            ) : sitedata?.theme_specialist === "overlay-reveal" ? (
                <OverlayRevealDoctors />
            ) : sitedata?.theme_specialist === "dropdown-cta" ? (
                <DoctorListing />
            ) : (
                <StaticDoctorListing />
            )}


        </>
    )
}

export default DoctorListingWrapper